import React from 'react';
import { ProgressBar, Popover } from '@brighterion/br-ui';
import { useTranslation } from 'react-i18next';
import { round } from 'lodash';
import clsx from 'clsx';
import styles from './index.css';

type Props = {
    row: { [key: string]: number };
    isRejectChart: boolean;
    totalRejectedMatches: number;
    chartType: string;
    value: number;
    maxBarValue: number | undefined;
    progressBarFillAreaStyle: string;
    totalSandBoxTransactions: number;
    totalDeployedTransactions: number;
};

const SimulationBarChart = ({
    row,
    isRejectChart,
    totalRejectedMatches,
    chartType,
    value,
    maxBarValue,
    progressBarFillAreaStyle,
    totalSandBoxTransactions,
    totalDeployedTransactions
}: Props) => {
    const label = chartType === 'all' ? row.percentTriggeredAll : row.percentTriggeredReject;
    const labelClassName = clsx(styles.progressBarLabel, round(label, 2) !== 0 && styles.notZero);
    const envLabel = progressBarFillAreaStyle.includes('Deployed') ? 'Deployed' : 'Sandbox';
    const { t } = useTranslation();
    return (
        <div className={styles.barContainer}>
            {row?.matches !== 0 ? (
                <Popover
                    isAltText
                    content={
                        <div>
                            <div className={styles.rulePopoverTitle}>{`${row?.rule} ${envLabel}`}</div>
                            <div className={styles.rulePopoverStats}>{`${row?.matches} ${t('out of')}
                            ${
                                isRejectChart
                                    ? t('triggeredRejectedTransactionsTooltip', {
                                          number: totalRejectedMatches
                                      })
                                    : t('totalTransactionsTooltip', {
                                          number:
                                              envLabel === 'Sandbox'
                                                  ? totalSandBoxTransactions
                                                  : totalDeployedTransactions
                                      })
                            }`}</div>
                            <div>{row?.description}</div>
                        </div>
                    }
                    contentClassName={styles.rulePopoverContent}
                    popperClassName={styles.popper}
                >
                    <ProgressBar
                        className={styles.progressBarWrapper}
                        fillAreaClass={styles[`${progressBarFillAreaStyle}`]}
                        labelClassName={labelClassName}
                        inlineLabel
                        labelPosition='back'
                        progress={round(Number(value) / (maxBarValue || 1), 4)}
                        labelOverride={round(label, 2)}
                        isTransparent
                    />
                </Popover>
            ) : null}
        </div>
    );
};
export default React.memo(SimulationBarChart);
